var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 131.3 79.1",
    style: {
      enableBackground: "new 0 0 131.3 79.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#333333;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n\t.st3{fill:url(#SVGID_3_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,68.1h4.5c3.5,0,5.8,2.2,5.8,5.4S8,78.9,4.5,78.9H0V68.1z M4.4,77.5c2.6,0,4.4-1.6,4.4-4.1 c0-2.3-1.8-4.1-4.4-4.1H1.5v8h2.9V77.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.7,68.1h1.5v10.6h-1.5V68.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.6,68.1v10.6h-1.3l-6.4-8v8h-1.5V68.1h1.3l6.4,8v-8H26.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.2,73.4h1.5v4.2c-1,0.9-2.5,1.3-4.1,1.3c-3.4,0-5.7-2.3-5.7-5.5s2.5-5.5,5.7-5.5c1.8,0,3.1,0.6,4.1,1.6 l-0.9,1.2c-0.9-0.9-1.9-1.2-3.1-1.2c-2.5,0-4.2,1.8-4.2,4.1c0,2.3,1.8,4.1,4.2,4.1c0.9,0,1.8-0.1,2.5-0.7V73.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.9,68.1h4.2c3.4,0,5.7,2.2,5.7,5.4c0,3.1-2.3,5.4-5.7,5.4h-4.2V68.1z M46.1,78.2c3.1,0,5-1.9,5-4.7 c0-2.8-1.9-4.7-5-4.7h-3.4v9.3C42.7,78.2,46.1,78.2,46.1,78.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.4,73.5c0-3.1,2.3-5.4,5.5-5.4s5.5,2.3,5.5,5.4s-2.3,5.4-5.5,5.4C55.9,78.9,53.4,76.6,53.4,73.5z M63.8,73.5 c0-2.8-2-4.7-4.8-4.7s-4.8,2-4.8,4.7c0,2.8,2,4.7,4.8,4.7C61.7,78.2,63.8,76.2,63.8,73.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76,68.1v10.6h-0.6l-7.3-9.3v9.3h-0.7V68.1h0.7l7.3,9.3v-9.3H76z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.4,73.5h0.7v3.9c-1,0.9-2.3,1.3-3.8,1.3c-3.2,0-5.5-2.3-5.5-5.4s2.3-5.4,5.5-5.4c1.6,0,2.9,0.4,3.8,1.5 L87.7,70c-0.9-0.9-2-1.3-3.4-1.3c-2.8,0-4.8,2-4.8,4.7c0,2.6,2,4.7,4.8,4.7c1.2,0,2.2-0.3,3.1-1C87.4,77.1,87.4,73.5,87.4,73.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.5,68.1v10.6h-1.3l-6.4-8v8h-1.5V68.1h1.3l6.4,8v-8H100.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.9,73.5c0-3.1,2.5-5.5,5.7-5.5s5.7,2.3,5.7,5.5s-2.5,5.5-5.7,5.5C105.2,78.9,102.9,76.6,102.9,73.5z  M112.6,73.5c0-2.3-1.8-4.1-4.1-4.1c-2.3,0-4.2,1.8-4.2,4.1c0,2.3,1.8,4.1,4.2,4.1C110.9,77.6,112.6,75.9,112.6,73.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.3,68.1l-3.5,10.6h-1.6l-2.9-8.6l-2.9,8.6h-1.6l-3.6-10.6h1.6l2.9,8.8l3.1-8.8h1.5l2.9,8.8l2.9-8.8H131.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 50,
    y1: -352.7936,
    x2: 91.349,
    y2: -352.7936,
    gradientTransform: "matrix(1 0 0 1 0 379.7436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF6633"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB900"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.3,0C59.1,0,54.1,1.5,50,4.1c6.6,1,13.3,2.2,19.8,3.2c1.5,0.3,2,0.6,2,1.3c0,5.5,0.1,11.1,0,16.6 c-0.3,6.7,0.3,13.6,0,20.3c0,1-1.2,1.6-2.9,1.8c-6.1,1-12.3,1.9-18.4,2.8c4.1,2.3,8.8,3.8,13.7,3.8c14.9,0,27-12.1,27-27 S79.4,0,64.3,0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.7824,
    y1: -352.6936,
    x2: 44.0563,
    y2: -352.6936,
    gradientTransform: "matrix(1 0 0 1 0 379.7436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.7,42.7c0.1-5.7-0.1-11.5,0-17.2c0.1-4.7,0-9.5,0-14.2c0-0.6-0.3-1-1-1.2c-5-1.2-9.8-2.5-14.7-3.6 c-1.5-0.4-3.1-0.7-4.5-1c-0.3,0-0.6,0-0.9,0V5.4c-0.6-0.1-1-0.1-1.5-0.3v43.5c0.4,0.1,1,0.1,1.8,0.4c0.3,0,0.6,0,0.9-0.1 c2.2-0.6,4.2-1.2,6.4-1.6c3.9-1,8-1.9,12-2.9C66.1,44.1,66.7,43.6,66.7,42.7z M63.9,28c-1.2,0-2.2-0.7-2.2-1.8c0-0.9,1-1.8,2.2-1.8 c1.2,0,2.2,0.7,2.2,1.8c0,0.6-0.3,1-0.9,1.3c0,0.1,0,0.1,0,0.3c-0.1,0-0.3,0-0.4-0.1C64.6,27.9,64.2,28,63.9,28z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 66.1,
    cy: -4601.6108,
    r: 38.2716,
    gradientTransform: "matrix(1 0 0 8.860728e-02 0 465.7359)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A3A3A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 66.1,
    cy: 58.1,
    rx: 38.2,
    ry: 3.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6ba17c2a8f04c121ef2203bfb583431e.svg";
export { ForwardRef as ReactComponent };